import { createComponent } from '@front/utils/alpine';
const quoteQuery = async (action, formData, csrfToken, signalController, method) => {
    const response = await fetch(action, {
        method: method,
        headers: {
            Accept: 'application/json',
            'X-CSRF-TOKEN': csrfToken || '',
        },
        body: formData,
        signal: signalController,
    });
    if (!response.ok) {
        throw new Error('Error! status: ${response.status}');
    }
    return response;
};
const quoteQueryUpdate = async (action, productId, productVariantId, extraParameters = {}) => {
    const response = await fetch('/quote', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            action,
            productId,
            productVariantId,
            ...extraParameters,
        }),
    });
    return response.text();
};
// Listing des produits tunnel devis
const HandleQuote = createComponent(() => ({
    productList: document.querySelector('.js-quote-product-list'),
    updatePage(e) {
        const parser = new DOMParser();
        const page = parser.parseFromString(e.detail.response, 'text/html');
        const products = page.querySelectorAll('.js-quote-product');
        const quoteItems = document.querySelectorAll('.js-quote-product');
        const quoteFooter = document.querySelector('.js-quote-footer');
        const updatedFooter = page.querySelector('.js-quote-footer');
        if (products.length) {
            // Remove old lines
            quoteItems.forEach((el) => {
                el.remove();
            });
            // Update existing lines
            products.forEach((product) => {
                this.productList.appendChild(product);
            });
        }
        else {
            const relateds = this.$refs.relateds;
            const products = this.$refs.products;
            const message = this.$refs.message;
            message.classList.remove('hidden');
            relateds.classList.remove('hidden');
            products.remove();
        }
        if (quoteFooter && updatedFooter) {
            quoteFooter.innerHTML = updatedFooter.innerHTML;
        }
    },
}));
// Produit dans le listing devis
const QuoteProduct = createComponent(() => ({
    controller: new AbortController(),
    isOpen: false,
    choice: '',
    code: '',
    product_id: 0,
    color_id: 0,
    variant_id: 0 || null,
    quantity: 0,
    hasColors: true,
    leftColors: [],
    async updateProduct(method) {
        this.controller.abort();
        this.controller = new AbortController();
        const product = this.$el.closest('.js-quote-product');
        const productId = this.product_id;
        const colorId = this.color_id;
        let productVariantId = Number(product.dataset.variant) ?? null;
        let qtyValue = this.quantity;
        if (method == 'quantity') {
            const qtyField = this.$refs.quantity;
            qtyValue = Number(qtyField.value);
        }
        if (method == 'duplicate' && this.getRandomAvailableVariant() != null) {
            productVariantId = this.getRandomAvailableVariant();
        }
        try {
            const response = await quoteQueryUpdate(method, productId, productVariantId, { colorId, qtyValue });
            window.dispatchEvent(new CustomEvent('product-update', {
                detail: { response: response },
            }));
        }
        catch (e) {
            console.log(e);
            return;
        }
    },
    // Vérification d'existence d'autres coloris du produit
    getColors() {
        const sameProducts = document.querySelectorAll(`.js-quote-product-${this.product_id}`);
        const metaVariantColors = this.$refs.meta;
        const colorsVariants = JSON.parse(metaVariantColors.content);
        if (colorsVariants.length > sameProducts.length) {
            this.hasColors = true;
        }
        else {
            this.hasColors = false;
        }
    },
    getRandomAvailableVariant() {
        const sameProducts = document.querySelectorAll(`.js-quote-product-${this.product_id}`);
        const metaVariantColors = this.$refs.meta;
        const colorsVariants = JSON.parse(metaVariantColors.content);
        const usedVariants = Array.from(sameProducts).map((product) => {
            const productElement = product;
            return Number(productElement.dataset.variant);
        });
        const availableVariants = colorsVariants
            .filter((variant) => {
            return !usedVariants.includes(variant.variant_id);
        })
            .map((variant) => variant.variant_id);
        if (availableVariants.length > 0) {
            const randomIndex = Math.floor(Math.random() * availableVariants.length);
            return availableVariants[randomIndex];
        }
        return null;
    },
}));
// Ajout du produit au devis
const AddToQuote = createComponent(() => ({
    controller: new AbortController(),
    choice: '',
    code: '',
    id: 0,
    isAddedToQuote: false,
    isLoading: false,
    isQtyTooLow: false,
    products: [],
    product_id: 0,
    color_id: 0,
    variant_id: 0 || null,
    quantity: 0,
    minQuantity: 0,
    checkMinQuantity() {
        this.isQtyTooLow = this.quantity >= this.minQuantity ? false : true;
    },
    // Synchronisation du coloris sélectionné pour envoyer à la requête d'ajout
    updateVariant(id) {
        const metaVariantColors = document.querySelector('meta[name="product-colors-variants"]');
        const variantInput = document.querySelector('.js-product-variant');
        const colorsVariants = JSON.parse(metaVariantColors.content);
        const currentSelection = colorsVariants.find((colorsVariant) => {
            if (colorsVariant.color_id == id) {
                return true;
            }
        });
        if (currentSelection) {
            this.variant_id = currentSelection.variant_id;
            variantInput.setAttribute('value', currentSelection.variant_id);
        }
    },
    // Requête ajout au devis
    async addToQuote(scroll, products) {
        this.controller.abort();
        this.controller = new AbortController();
        const app = JSON.parse(document
            .querySelector('meta[name="app"]')
            .getAttribute('content'));
        const csrfToken = app.token;
        const actionRoute = app.quote.urls.add;
        const formData = new FormData();
        formData.append('products', JSON.stringify(products));
        const response = (await quoteQuery(actionRoute, formData, csrfToken, this.controller.signal, 'POST'));
        const json = await response.json();
        if (json.success && json.data && json.data.products) {
            if (scroll && window.innerWidth >= 1024) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            }
            this.isAddedToQuote = true;
            document.dispatchEvent(new CustomEvent('open-cart', {
                detail: {
                    products: json.data.products,
                    count: json.data.count,
                },
            }));
        }
        return json;
    },
}));
// Popin produit ajouté au devis
const QuoteCart = createComponent(() => ({
    isCartOpen: false,
    scrolled: false,
    products: [],
    productCount: 0,
    init() {
        window.addEventListener('scroll', () => {
            this.scrolled = window.scrollY > 200;
        });
        const countInput = this.$refs.productCount;
        this.productCount = +countInput.value;
        const onOpenCart = (event) => {
            const customEvent = event;
            const products = customEvent.detail.products;
            if (products)
                this.products = products;
            this.productCount = customEvent.detail.count;
            this.openCart();
        };
        document.addEventListener('open-cart', onOpenCart);
    },
    openCart() {
        this.isCartOpen = true;
    },
    closeCart() {
        this.isCartOpen = false;
    },
}));
const Quote = { HandleQuote, AddToQuote, QuoteCart, QuoteProduct };
export { Quote };
